import io from 'socket.io-client';

const socket = io('https://theofficeconnected.com', {
  withCredentials: true,
  extraHeaders: {
    "my-custom-header": "abcd"
  }
});

export default socket;
